export enum DirectPaths {
    HOME = "/",
    PLATFORM = "/platform",
    UNLISTED_SHARES = "/unlisted-shares",
    DOCVAULT = "/doc-vault",
    CALCULATOR = "/calculators",
    UE_DISCLAIMER = "/unlisted-shares/disclaimer",
    INVESTOR_RELATIONS = "/investor-relations",
    DISCLAIMER = "/disclaimer",
    CONTACT = "/contact",
    PRIVACY_POLICY = "/privacy-policy",
    TERMS_AND_CONDITIONS = "/terms-of-use",
    ANNOUNCEMENT = "/announcement",
    MILESTONE = "/milestone",
}

export enum Subdomains {
    HOME = "dev",
}

export enum PathPrefixes {
    HOME = "/home",
}

type SubdomainConfig = {
    prefix: PathPrefixes;
    exceptions: DirectPaths[];
};

type RouteConfiguration = {
    [key in Subdomains]: SubdomainConfig;
};

export const routeConfig: RouteConfiguration = {
    [Subdomains.HOME]: {
        prefix: PathPrefixes.HOME,
        exceptions: [DirectPaths.UNLISTED_SHARES, DirectPaths.DOCVAULT],
    },
};
